import React from 'react';

export const calendarOutline = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect
        x='4'
        y='4'
        width='16'
        height='16'
        rx='3.75'
        stroke='#023F80'
        strokeWidth='1.8'
      />
      <path
        d='M16 2.40002V5.60002'
        stroke='#023F80'
        strokeWidth='1.8'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8 2.40002V5.60002'
        stroke='#023F80'
        strokeWidth='1.8'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M4 10H20' stroke='#023F80' strokeWidth='1.8' />
      <circle cx='15.5' cy='15.5' r='1' stroke='#023F80' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M16 1.5C16.497 1.5 16.9 1.90294 16.9 2.4V3.19126C17.4323 3.25787 17.9119 3.37803 18.361 3.60686C19.236 4.05267 19.9473 4.76403 20.3932 5.63898C20.6729 6.18809 20.7903 6.78278 20.8459 7.46376C20.9 8.12585 20.9 8.94407 20.9 9.96134V14.0387C20.9 15.056 20.9 15.8742 20.8459 16.5363C20.7903 17.2173 20.6729 17.812 20.3932 18.3611C19.9473 19.236 19.236 19.9474 18.361 20.3932C17.8119 20.673 17.2172 20.7903 16.5363 20.846C15.8742 20.9001 15.0559 20.9 14.0387 20.9H9.96128C8.944 20.9 8.12579 20.9001 7.46369 20.846C6.78272 20.7903 6.18803 20.673 5.63892 20.3932C4.76397 19.9474 4.05261 19.236 3.6068 18.3611C3.32701 17.812 3.20969 17.2173 3.15406 16.5363C3.09996 15.8742 3.09997 15.056 3.09998 14.0387V9.96134C3.09997 8.94407 3.09996 8.12585 3.15406 7.46376C3.20969 6.78278 3.32701 6.18809 3.6068 5.63898C4.05261 4.76403 4.76397 4.05267 5.63892 3.60686C6.08802 3.37803 6.56762 3.25788 7.09998 3.19126V2.4C7.09998 1.90294 7.50292 1.5 7.99998 1.5C8.49703 1.5 8.89998 1.90294 8.89998 2.4V3.10287C9.22731 3.10003 9.5803 3.10003 9.96119 3.10004H9.96128H14.0387H14.0388C14.4197 3.10003 14.7726 3.10003 15.1 3.10287V2.4C15.1 1.90294 15.5029 1.5 16 1.5ZM7.09998 5.01069V5.6C7.09998 6.09706 7.50292 6.5 7.99998 6.5C8.49703 6.5 8.89998 6.09706 8.89998 5.6V4.903C9.22481 4.90014 9.58848 4.90004 9.99998 4.90004H14C14.4115 4.90004 14.7751 4.90014 15.1 4.903V5.6C15.1 6.09706 15.5029 6.5 16 6.5C16.497 6.5 16.9 6.09706 16.9 5.6V5.01069C17.1783 5.0596 17.3779 5.12613 17.5438 5.21067C18.0801 5.48391 18.5161 5.9199 18.7893 6.45616C18.9183 6.70923 19.0053 7.04067 19.0519 7.61033C19.0846 8.01124 19.0951 8.49065 19.0984 9.10004H4.90153C4.90487 8.49065 4.91532 8.01124 4.94808 7.61033C4.99462 7.04067 5.08167 6.70923 5.21061 6.45616C5.48385 5.9199 5.91984 5.48391 6.4561 5.21067C6.62202 5.12613 6.82163 5.0596 7.09998 5.01069ZM4.89998 10.9H19.1V14C19.1 15.065 19.0993 15.8096 19.0519 16.3897C19.0053 16.9594 18.9183 17.2908 18.7893 17.5439C18.5161 18.0802 18.0801 18.5162 17.5438 18.7894C17.2908 18.9183 16.9593 19.0054 16.3897 19.0519C15.8095 19.0993 15.0649 19.1 14 19.1H9.99998C8.93503 19.1 8.19044 19.0993 7.61027 19.0519C7.04061 19.0054 6.70917 18.9183 6.4561 18.7894C5.91984 18.5162 5.48385 18.0802 5.21061 17.5439C5.08167 17.2908 4.99462 16.9594 4.94808 16.3897C4.90068 15.8096 4.89998 15.065 4.89998 14V10.9ZM15.5 17C16.3284 17 17 16.3284 17 15.5C17 14.6716 16.3284 14 15.5 14C14.6715 14 14 14.6716 14 15.5C14 16.3284 14.6715 17 15.5 17Z'
        fill='#023F80'
      />
    </svg>
  );
};
